import {
  AccordionActionType,
  EmptyFieldsAccordionActionAnalyticsEvent,
} from "./analyticsLib093IssuesEvents";
import { trackEvent } from "@adsk/acc-issues-core/utils/analytics/trackEvent";

const trackCollapseExpandAction = (action: AccordionActionType) => {
  trackEvent(new EmptyFieldsAccordionActionAnalyticsEvent({ action: action }));
};

export const trackCollapseExpandOpen = () => {
  trackCollapseExpandAction(AccordionActionType.OPEN);
};

export const trackCollapseExpandClose = () => {
  trackCollapseExpandAction(AccordionActionType.CLOSE);
};
